import React from 'react';
import { Switch, Route } from 'react-router';
import { LANGUAGES } from '../_i18n/languages';
import loadable from '@loadable/component';

const Terms = loadable(() => import('../terms/Terms'));
const Privacy = loadable(() => import('../privacy/Privacy'));
const NotFound = loadable(() => import('../notFound/NotFound'));
const Stopwatch = loadable(() => import('../stopwatch/Stopwatch'));
const Timer = loadable(() => import('../timer/Timer'));
const Clock = loadable(() => import('../clock/Clock'));
const TimeDifference = loadable(() => import('../clock/TimeDifference'));

const MultiLanguageRoute = (props) => {
    const hasLang = props.computedMatch?.params?.lang || 'en';
    const currentLanguage = LANGUAGES[hasLang];

    if (!currentLanguage) return <Route component={NotFound} />;

    return <Route {...props} />;
};

const router = () => (
    <React.Fragment>
        <Switch>
            <Route exact path='/' component={Clock} />
            <Route path='/terms' component={Terms} />
            <Route path='/privacy' component={Privacy} />

            {/* Root English routes (without /:lang prefix) */}
            <Route exact path='/countdown-timer' component={Timer} />
            <Route exact path='/stopwatch' component={Stopwatch} />
            <Route exact path='/time-difference' component={TimeDifference} />
            <Route exact path='/time-difference/:pair' component={TimeDifference} />
            <Route exact path='/time/:city' component={Clock} />

            {/* Multilingual routes (with /:lang prefix) */}
            <MultiLanguageRoute exact path='/:lang/countdown-timer' component={Timer} />
            <MultiLanguageRoute exact path='/:lang/stopwatch' component={Stopwatch} />
            <MultiLanguageRoute exact path='/:lang/time-difference' component={TimeDifference} />
            <MultiLanguageRoute exact path='/:lang/time-difference/:pair' component={TimeDifference} />
            <MultiLanguageRoute exact path='/:lang/time/:city' component={Clock} />
            <MultiLanguageRoute exact path='/:lang/terms' component={Terms} />
            <MultiLanguageRoute exact path='/:lang/privacy' component={Privacy} />
            <MultiLanguageRoute exact path='/:lang' component={Clock} />
            <MultiLanguageRoute exact path='/:lang/:cityTz' component={Clock} />
            <Route exact path='/:cityTz([a-zA-Z0-9_\-+%]+,[a-zA-Z0-9_\-+%]+,[a-zA-Z0-9_\-+%]+)' component={Clock} />

            <Route component={NotFound} />
        </Switch>
    </React.Fragment>
);

export default router;